import React from "react";
import styled from "../../lib/styled";
import { Layer, Carousel } from "grommet";

interface GalleryImageProps {
  coverImage: string;
  images: string[];
}
export const GalleryBlock: React.FC<GalleryImageProps> = (props) => {
  const [show, setShow] = React.useState<boolean>(false);

  const slides = React.useMemo(() => {
    const slideImages = [];
    {
      props.images.forEach((imageUrl) => {
        if (imageUrl) {
          slideImages.push(imageUrl);
        }
      });
    }
    return slideImages;
  }, [props.images]);

  return (
    <GalleryWrapper onClick={() => setShow(true)}>
      <GalleryMessage>View gallery</GalleryMessage>
      <CoverImage image={props.coverImage} />
      {show && (
        <StyledLayer
          onEsc={() => setShow(false)}
          onClickOutside={() => setShow(false)}
        >
          <Carousel fill>
            {slides.map((imageUrl) => {
              return <CarouselImage src={imageUrl} />;
            })}
          </Carousel>
        </StyledLayer>
      )}
    </GalleryWrapper>
  );
};

const StyledLayer = styled(Layer)`
  max-height: 90vh;
  max-width: 90vw;
`;

const GalleryWrapper = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 28.125%;
  padding-top: 28.125%;
  cursor: pointer;
  background-color: ${({ theme }) => theme.color.darkThree};
  margin-bottom: 15px;
`;

const GalleryMessage = styled.div`
  position: absolute;
  z-index: 10;
  font-family: "Keep Calm";
  letter-spacing: 2px;
  color: white;
  text-shadow: 0 0 3px #00000073;
  text-transform: uppercase;
  text-align: center;
`;

const CoverImage = styled.div<{ image: string }>`
  width: 100%;
  height: 100%;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
`;

const CarouselImage = styled.img`
  margin: 0;
  max-height: 90vh;
  max-width: 90vw;
`;
